(function () {
  if (window.__productAvailabilityToggleBound) return;
  window.__productAvailabilityToggleBound = true;

  var UNAVAILABLE_CLASS = 'is-variant-unavailable';
  var BIS_TEXT_PATTERN = /notify me|email when available|email me when available|back in stock/i;
  var BIS_MANAGED_ATTR = 'availabilityManaged';

  function getScope(el) {
    return el.closest('product-info') || document;
  }

  function isRowUnavailable(row) {
    return !!row && row.classList.contains(UNAVAILABLE_CLASS);
  }

  function findRelatedRow(el) {
    var scope = getScope(el);
    var row = scope.querySelector ? scope.querySelector('[data-buy-buttons-row]') : null;
    if (row) return row;

    // Fallback: if we can't resolve a scoped row (e.g. the app injected its
    // button outside <product-info>), and there's only one row on the page,
    // assume it belongs to that row rather than defaulting to "unavailable".
    var rows = document.querySelectorAll('[data-buy-buttons-row]');
    return rows.length === 1 ? rows[0] : null;
  }

  function syncBisElement(el) {
    var row = findRelatedRow(el);
    // If we genuinely can't tell, default to hidden. Showing a stray
    // "notify me" button on an in-stock product is worse than the reverse.
    var unavailable = row ? isRowUnavailable(row) : false;
    el.style.display = unavailable ? '' : 'none';
  }

  function looksLikeBisTrigger(el) {
    if (!el || el.dataset[BIS_MANAGED_ATTR] === 'true') return false;
    if (el.tagName !== 'BUTTON' && el.tagName !== 'A') return false;
    var text = (el.textContent || '').trim();
    if (!text || text.length > 60) return false;
    return BIS_TEXT_PATTERN.test(text);
  }

  function tagAndSyncBisElement(el) {
    if (!el || el.dataset[BIS_MANAGED_ATTR] === 'true') return;
    el.dataset[BIS_MANAGED_ATTR] = 'true';
    el.classList.add('js-back-in-stock-trigger');
    syncBisElement(el);
    // Some apps toggle their own button's visibility asynchronously (e.g.
    // after their own stock check). Watch the element itself so we can
    // immediately re-apply our decision if it tries to reveal itself.
    selfObserver.observe(el, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
  }

  function scanForBisElements(scope) {
    (scope || document).querySelectorAll('button, a').forEach(function (el) {
      if (looksLikeBisTrigger(el)) {
        tagAndSyncBisElement(el);
      }
    });
  }

  function syncKnownBisElements(scope) {
    (scope || document).querySelectorAll('.js-back-in-stock-trigger').forEach(syncBisElement);
  }

  var selfObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      var target = mutation.target;
      if (target && target.nodeType === 1) syncBisElement(target);
    });
  });

  function syncRow(submitButton) {
    var row = submitButton.closest('[data-buy-buttons-row]');
    if (!row) return;
    row.classList.toggle(UNAVAILABLE_CLASS, submitButton.hasAttribute('disabled'));

    var scope = getScope(row);
    syncKnownBisElements(scope);
  }

  function syncAll(scope) {
    (scope || document).querySelectorAll('[data-buy-buttons-row] .product-form__submit').forEach(syncRow);
    scanForBisElements(scope);
  }

  var attributeObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      var target = mutation.target;
      if (target && target.nodeType === 1 && target.classList.contains('product-form__submit')) {
        syncRow(target);
      }
    });
  });

  attributeObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['disabled'],
    subtree: true,
  });

  function checkCandidate(node) {
    if (!node) return;
    if (node.nodeType === 3) node = node.parentElement;
    if (!node || node.nodeType !== 1) return;

    // The button itself may already exist and only have its label filled
    // in later (e.g. an app renders an empty placeholder, then sets its
    // text once an async stock check resolves), so check the element and
    // its closest button/link ancestor before bothering with a subtree scan.
    if (looksLikeBisTrigger(node)) {
      tagAndSyncBisElement(node);
      return;
    }

    var ownTrigger = node.tagName === 'BUTTON' || node.tagName === 'A' ? node : node.closest && node.closest('button, a');
    if (ownTrigger) {
      if (looksLikeBisTrigger(ownTrigger)) tagAndSyncBisElement(ownTrigger);
      return;
    }

    if (node.querySelectorAll) {
      node.querySelectorAll('button, a').forEach(function (el) {
        if (looksLikeBisTrigger(el)) tagAndSyncBisElement(el);
      });
    }
  }

  var additionObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'characterData') {
        checkCandidate(mutation.target);
        return;
      }
      checkCandidate(mutation.target);
      mutation.addedNodes.forEach(checkCandidate);
    });
  });

  additionObserver.observe(document.body, { childList: true, subtree: true, characterData: true });

  document.addEventListener('shopify:section:load', function (event) {
    syncAll(event.target);
  });

  syncAll();

  // Safety net: some back-in-stock apps load their own script late and can
  // briefly re-show their button after their own async stock check. Keep
  // re-asserting our decision for a few seconds after load to close that gap.
  var pollAttempts = 0;
  var pollId = setInterval(function () {
    pollAttempts += 1;
    syncAll();
    if (pollAttempts >= 20) clearInterval(pollId);
  }, 250);
})();
